<template>
  <div class="row mb-3">
    <div class="col-sm-6">
      <h1 v-text="title"></h1>
    </div>
    <div class="col-sm-6">
      <ol class="breadcrumb float-sm-right">
        <li class="breadcrumb-item">
            <inertia-link :href="route('dashboard')" v-text="$t('front.home')"></inertia-link>
        </li>
        <slot />
        <li class="breadcrumb-item active" v-text="title"></li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        title: String,
    },
}
</script>